export default (defaultMessage, props) =>
  (props.validationErrors && props.validationErrors.required) ||
  props.validationError ||
  defaultMessage;
